import React, { useState, useEffect } from "react";
import searchIcon from "../assets/images/search6.png";
import "../styles/Termsofuse.css";
import { ReactComponent as AppStore } from '../assets/images/appstore.svg';
import { ReactComponent as PlayStore } from '../assets/images/googleplay.svg';

const DriverRequirements = () => {
  return (
    <div className="legal-wrappersss">
      <main className="legal-main">
        
        <p className="intro-paragraph">
          At BERYMO, Inc., our top priority is the safety and security of our
          riders and the communities we serve. To maintain a trustworthy and
          reliable platform, all drivers must meet the following
          requirements. These standards are essential for ensuring a professional
          and safe experience for everyone on the BERYMO platform.
        </p>
        <hr />
        <h3>1. Driver's License</h3>
        <p>
          To operate with BERYMO, Inc., you must possess a valid driver's license issued by the state or jurisdiction in which you intend to provide transportation services. The license must be current and not suspended, revoked, or expired.
        </p>
        <p>
          <strong>
            You are required to upload a clear, legible photo of your driver's
            license through the BERYMO DRIVER mobile application. The uploaded
            image must show all details, including your name, date of birth,
            license number, issue date, and expiration date.
          </strong>
        </p>
        <p>
          BERYMO, Inc. reserves the right to verify the authenticity of the
          driver's license with the relevant authorities. Failure to provide a
          valid driver's license will result in the inability to receive Ride
          Opportunities.
        </p>
        <hr />
        <h3>2. Vehicle Insurance</h3>
        <p>
          All drivers must maintain valid vehicle insurance that meets or exceeds
          the minimum requirements set by the state or jurisdiction in which they
          operate. The insurance policy must cover the vehicle used for performing
          Contracted Services and include liability coverage for bodily injury and
          property damage.
        </p>
        <p>
          <strong>
            You are required to upload a copy of your current vehicle insurance
            policy or insurance card through the BERYMO DRIVER mobile application.
            The document must clearly display the policyholder's name, vehicle
            details (make, model, year, and VIN), coverage amounts, and policy
            effective and expiration dates.
          </strong>
        </p>
        <p>
          Drivers must promptly update their insurance information in the BERYMO
          DRIVER mobile application whenever a policy is renewed or changed.
          Failure to maintain valid insurance or provide updated documentation will
          result in deactivation from the platform.
        </p>
        <hr />
        <h3>3. Vehicle Inspection</h3>
        <p>
          The vehicle used for Contracted Services must pass a vehicle inspection
          conducted by a licensed mechanic or authorized inspection facility in
          accordance with local regulations. The inspection ensures that the
          vehicle is safe, roadworthy, and compliant with all applicable laws.
        </p>
        <p>
          <strong>
            You must upload a photo or scanned copy of the vehicle inspection
            report through the BERYMO DRIVER mobile application. The report must
            include the inspection date, vehicle details (make, model, year, and
            VIN), and confirmation that the vehicle passed the inspection.
          </strong>
        </p>
        <p>
          Vehicles must be re-inspected as required by local laws or at BERYMO,
          Inc.'s discretion. Failure to provide a valid inspection report will
          prevent you from receiving Ride Opportunities.
        </p>
        <hr />
        <h3>4. Profile Photo</h3>
        <p>
          To ensure trust and safety for riders, all drivers must provide a clear
          and recent profile photo for identification purposes. The photo will be
          visible to riders through the BERYMO or BERYMO PLACES mobile
          applications.
        </p>
        <p>
          <strong>
            You are required to upload a professional-quality headshot through the
            BERYMO DRIVER mobile application. The photo must clearly show your
            face, be well-lit, and taken against a plain background. Photos that
            are blurry, low-quality, or include other individuals or objects will
            not be accepted.
          </strong>
        </p>
        <p>
          BERYMO, Inc. reserves the right to reject profile photos that do not meet
          these standards. Drivers must update their profile photo if requested by
          BERYMO, Inc. to ensure it remains current.
        </p>
        <hr />
        <h3>5. Background Check and Criminal History</h3>
        <p>
          To maintain a safe environment for riders and partners, all drivers must
          undergo a background check conducted by BERYMO, Inc. or a third-party
          provider. The background check will review your criminal history and
          driving record to ensure compliance with BERYMO, Inc.'s safety
          standards.
        </p>
        <p>
          <strong>
            Drivers must have no pending criminal cases, convictions for violent
            crimes, sexual offenses, or driving-related offenses (such as DUI or
            reckless driving) within the past seven years, or as otherwise
            required by local law. Any driver with a criminal history that violates
            BERYMO, Inc.'s safety policies will be ineligible to provide Contracted
            Services.
          </strong>
        </p>
        <p>
          You must consent to the background check process through the BERYMO
          DRIVER mobile application and provide any necessary information, such as
          your full name, date of birth, and Social Security Number (or equivalent
          identification number). Failure to pass the background check or provide
          accurate information will result in deactivation from the platform.
        </p>
        <hr />
        <h3>6. Compliance with BERYMO Policies</h3>
        <p>
          In addition to the above requirements, drivers must comply with all
          BERYMO, Inc. policies, including but not limited to the Terms of Service,
          Community Guidelines, and Independent Contractor Agreement. Failure to
          meet these requirements or adhere to policies may result in temporary
          suspension or permanent deactivation from the BERYMO platform.
        </p>
        <p>
          <strong>
            BERYMO, Inc. reserves the right to request additional documentation or
            verification at any time to ensure ongoing compliance with these
            requirements.
          </strong>
        </p>
        <p>
          By submitting the required documents and consenting to the background
          check, you acknowledge that you have read, understood, and agree to
          comply with these Driver Requirements and all related policies.
        </p>

        <section className="ready-to-apply">
          <hr />
          <h2>Ready to Get Started?</h2>
          <p>
            If you meet all the requirements listed above and are ready to begin
            the application process, please download the BERYMO DRIVER mobile app.
          </p>
      
        </section>
      </main>
    </div>
  );
};

// Content Loader Component
const ContentLoader = ({ isMobile }) => {
  const shimmerAnimation = `
    @keyframes shimmer {
      0% {
        background-position: -468px 0;
      }
      100% {
        background-position: 468px 0;
      }
    }
  `;

  const loaderStyles = {
    container: {
      padding: "20px",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      backgroundColor: "#fff",
      position: "relative",
    },
    line: {
      height: isMobile ? "12px" : "14px",
      borderRadius: "4px",
      marginBottom: "8px",
      backgroundColor: "#e0e0e0",
      backgroundImage: "linear-gradient(to right, #f0f0f0 0%, #e8e8e8 20%, #f0f0f0 40%, #f0f0f0 100%)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "800px 104px",
      animation: "shimmer 1.2s linear infinite",
    },
    heading: {
      width: "70%",
      height: isMobile ? "20px" : "24px",
      borderRadius: "4px",
      marginBottom: "20px",
      backgroundColor: "#e0e0e0",
      backgroundImage: "linear-gradient(to right, #f0f0f0 0%, #e8e8e8 20%, #f0f0f0 40%, #f0f0f0 100%)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "800px 104px",
      animation: "shimmer 1.2s linear infinite",
    },
  };

  return (
    <>
      <style>{shimmerAnimation}</style>
      <div style={loaderStyles.container}>
        <div style={loaderStyles.heading}></div>
        <div style={{ ...loaderStyles.line, width: "100%" }}></div>
        <div style={{ ...loaderStyles.line, width: "80%" }}></div>
        <div style={{ ...loaderStyles.line, width: "90%" }}></div>
        <div style={{ ...loaderStyles.line, width: "75%" }}></div>
        <div style={{ ...loaderStyles.line, width: "85%" }}></div>
      </div>
    </>
  );
};

const HelpDriver = () => {
  const [query, setQuery] = useState("");
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isFocused, setIsFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const topics = [
    "Sign up", "Trips", "Account & app", "Earnings", "EVs", "Guides",
    "Safety", "Appointment", "Accessibility", "Shuttle", "Privacy",
    "Map issues", "Driver Requirements",
  ];

  const topicContent = {
    "Sign up": {
      heading: "Signing Up as a Driver",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Join Berymo as a driver to start earning by providing rides or deliveries.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Steps to sign up:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Download the Berymo Driver app.</li>
            <li>Submit your details, including ID, driver’s license, and vehicle information.</li>
            <li>Pass the background check and vehicle inspection.</li>
            <li>Start driving once approved.</li>
          </ul>
        </>
      ),
    },
    "Trips": {
      heading: "Managing Trips",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Learn how to manage your trips effectively to provide a great experience for riders.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To start a trip:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Accept a trip request in the app.</li>
            <li>Navigate to the pickup location.</li>
            <li>Start the trip once the rider is on board.</li>
            <li>End the trip after reaching the destination.</li>
          </ul>
        </>
      ),
    },
    "Account & app": {
      heading: "Account and App Management",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Manage your driver account and app settings to optimize your experience.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To update your account:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Go to the Account section in the app.</li>
            <li>Update your personal details or vehicle information.</li>
            <li>Save changes.</li>
          </ul>
        </>
      ),
    },
    "Earnings": {
      heading: "Tracking Your Earnings",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Keep track of your earnings to manage your finances as a driver.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To view earnings:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Go to the Earnings section in the app.</li>
            <li>View your trip earnings and bonuses.</li>
            <li>Check payment schedules.</li>
          </ul>
        </>
      ),
    },
    "EVs": {
      heading: "Electric Driving",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Berymo supports electric vehicle (EV) drivers with special incentives.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Benefits for EV drivers:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Higher earnings per trip.</li>
            <li>Access to EV charging discounts.</li>
            <li>Priority in certain areas.</li>
          </ul>
        </>
      ),
    },
    "Guides": {
      heading: "Driver Guides",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Access guides to help you succeed as a Berymo driver.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Available guides:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>How to maximize earnings.</li>
            <li>Safety tips for drivers.</li>
            <li>Navigating the app efficiently.</li>
          </ul>
        </>
      ),
    },
    "Safety": {
      heading: "Driver Safety",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Your safety is a priority while driving with Berymo.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Safety features:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Emergency SOS button in the app.</li>
            <li>Share trip details with a trusted contact.</li>
            <li>24/7 support for safety concerns.</li>
          </ul>
        </>
      ),
    },
    "Appointment": {
      heading: "Scheduling Appointments",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Schedule rides in advance for riders who need appointments.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To manage appointments:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>View scheduled rides in the app.</li>
            <li>Accept or decline based on availability.</li>
            <li>Arrive on time for the scheduled pickup.</li>
          </ul>
        </>
      ),
    },
    "Accessibility": {
      heading: "Accessibility for Drivers",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Berymo provides accessibility features for drivers with disabilities.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Available features:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Voice commands for hands-free operation.</li>
            <li>High-contrast mode for better visibility.</li>
            <li>Support for hearing-impaired drivers.</li>
          </ul>
        </>
      ),
    },
    "Shuttle": {
      heading: "Shuttle Services",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Berymo offers shuttle services in select cities for group transportation.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            To drive a shuttle:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Sign up for shuttle services in the app.</li>
            <li>Follow the designated route and schedule.</li>
            <li>Ensure all passengers are accounted for.</li>
          </ul>
        </>
      ),
    },
    "Privacy": {
      heading: "Driver Privacy",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Berymo protects your privacy as a driver.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Privacy measures:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Your personal information is encrypted.</li>
            <li>Share only necessary details with riders.</li>
            <li>Control what data you share in the app settings.</li>
          </ul>
        </>
      ),
    },
    "Map issues": {
      heading: "Resolving Map Issues",
      content: (
        <>
          <p style={{ marginBottom: "16px", fontSize: isMobile ? "16px" : "17px" }}>
            Facing issues with the map? Here’s how to fix common problems.
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "8px", fontSize: isMobile ? "19px" : "19px" }}>
            Troubleshooting steps:
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "16px", fontSize: isMobile ? "15px" : "15px" }}>
            <li>Ensure GPS is enabled on your device.</li>
            <li>Update the app to the latest version.</li>
            <li>Restart the app if the map freezes.</li>
            <li>Contact support for persistent issues.</li>
          </ul>
        </>
      ),
    },
    "Driver Requirements": {
      heading: "Driver Requirements",
      content: <DriverRequirements />
    },
  };

  const handleTopicClick = (topic) => {
    setIsLoading(true);
    setSelectedTopic(topic);
    setTimeout(() => {
      setIsLoading(false);
    }, 700);
  };

  const closeModal = () => {
    setSelectedTopic(null);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const filteredTopics = topics.filter((topic) =>
    topic.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div
      style={{
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#333",
        margin: "0 auto",
      }}
    >
      {/* Header and Search Bar - Always Visible */}
      <div
        style={{
          backgroundColor: "#FEF4F5",
          padding: isMobile ? "40px 16px" : "60px 0",
          marginTop: isMobile ? "30px" : "0",
        }}
      >
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "left",
            ...(isMobile ? { paddingLeft: "16px" } : { marginLeft: "360px" }),
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? "24px" : "28px",
              fontWeight: "bold",
              marginBottom: "12px",
              color: "#000",
            }}
          >
            Support Resources for Berymo Drivers
          </h1>
          <p
            style={{
              fontSize: isMobile ? "14px" : "15px",
              color: "#555",
              lineHeight: "1.5",
              marginBottom: "20px",
            }}
          >
            Looking for contact information? While we don’t offer a customer service number for Berymo drivers, you can log in to your account to get personalized support or explore the resources below to find solutions to issues related to driving and delivering with Berymo.
          </p>

          {/* Search Bar */}
          <div style={{ position: "relative", width: isMobile ? "100%" : "550px" }}>
            <span
              style={{
                position: "absolute",
                left: "12px",
                top: "40%",
                transform: "translateY(-50%)",
              }}
            >
              <img
                src={searchIcon}
                alt="Search Icon"
                style={{ width: "20px", height: "20px" }}
              />
            </span>
            <input
              type="text"
              placeholder="Search questions, Keywords,Topics"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={{
                width: isMobile && isFocused ? "100%" : "100%",
                padding: isMobile ? "12px 14px 12px 40px" : "14px 16px 14px 40px",
                border: `1px solid ${isFocused ? '#fd5c63' : '#fff0f1'}`,
                borderRadius: "5px",
                fontSize: isMobile ? "14px" : "16px",
                color: "#333",
                backgroundColor: isFocused ? "#fff" : "#FFFFFF",
                outline: "none",
                transition: "width 0.3s ease, border-color 0.3s ease, background-color 0.3s ease",
              }}
            />
            {/* Conditional 'X' icon */}
            {query && (
              <span
                onClick={() => setQuery("")}
                style={{
                  position: "absolute",
                  right: window.innerWidth <= 768 ? "12px" : "15px",
                  transform: "translateY(-300%)",
                  cursor: "pointer",
                  color: "#fff",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "15px",
                  height: "15px",
                  backgroundColor: "#fd5c63",
                  borderRadius: "50%",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    top: window.innerWidth <= 768 ? "-1px" : "-1px",
                  }}
                >
                  ×
                </span>
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Main content area */}
      <div
        style={{
          maxWidth: "800px",
          margin: isMobile ? "0 auto" : "0 0 0 360px",
          padding: isMobile ? "24px 16px 24px 32px" : "40px 0",
        }}
      >
        {isLoading ? (
          <ContentLoader isMobile={isMobile} />
        ) : selectedTopic ? (
          // Responsive Card Container
          <div
            style={{
              padding: isMobile ? "20px" : "30px",
              borderRadius: isMobile ? "0" : "15px",
              boxShadow: isMobile ? "none" : "0 10px 30px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
              position: isMobile ? "fixed" : "relative",
              top: isMobile ? "0" : "auto",
              left: isMobile ? "0" : "auto",
              width: isMobile ? "100%" : "auto",
              height: isMobile ? "100%" : "auto",
              overflowY: isMobile ? "auto" : "visible",
              zIndex: isMobile ? "1000" : "auto",
              transform: isMobile ? "translateY(0)" : "none",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <button
              style={{
                position: "absolute",
                top: isMobile ? "35px" : "15px",
                right: isMobile ? "-150px" : "-355px",
                background: "none",
                border: "none",
                fontSize: isMobile ? "38px" : "38px", // Increased size
                fontWeight: "300",
                color: "#000",
                cursor: "pointer",
                padding: "5px",
                zIndex: "1001",
                transition: "color 0.3s, transform 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.color = "#fd5c63")}
              onMouseOut={(e) => (e.target.style.color = "#000")}
              onClick={closeModal}
            >
              ×
            </button>
            <h2
              style={{
                fontSize: isMobile ? "24px" : "28px",
                fontWeight: "bold",
                marginBottom: "20px",
                color: "#222",
                paddingTop: isMobile ? "30px" : "0",
              }}
            >
              {topicContent[selectedTopic]?.heading}
            </h2>
            <div
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#555",
                lineHeight: "1.6",
              }}
            >
              {topicContent[selectedTopic]?.content}
            </div>
            <button
              style={{
                marginTop: "30px",
                padding: isMobile ? "12px 24px" : "14px 28px",
                backgroundColor: "#fd5c63",
                color: "#fff",
                border: "none",
                borderRadius: "25px",
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "block",
                margin: "30px auto 0",
                transition: "background-color 0.3s, transform 0.2s",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#474747";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#fd5c63";
                e.target.style.transform = "scale(1)";
              }}
              onClick={() =>
                (window.location.href = "https://apps.apple.com/us/app/berymo-driver/id1440035432")
              }
            >
              Log in to Get Help
            </button>
          </div>
        ) : (
          <div>
            <h2
              style={{
                fontSize: isMobile ? "20px" : "24px",
                fontWeight: "bold",
                marginBottom: "20px",
                color: "#000",
                textAlign: "left",
              }}
            >
              All Topics
            </h2>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {filteredTopics.map((topic, index) => (
                <li
                  key={index}
                  onClick={() => handleTopicClick(topic)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: isMobile ? "16px 0" : "20px 0",
                    borderBottom: "1px solid #eee",
                    fontSize: isMobile ? "14px" : "16px",
                    color: "#000",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#f9f9f9")}
                  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "10px", fontSize: isMobile ? "18px" : "20px" }}>
                      ≡
                    </span>
                    {topic}
                  </div>
                  <span style={{ fontSize: isMobile ? "18px" : "20px", color: "#999" }}>›</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpDriver;